__turbopack_context__.v({
  "root": "styles-module-scss-module__gozyEq__root",
});
